import type { LessonContentData } from "./lessonContentTypes";

/**
 * Legacy lesson content map — intentionally empty.
 *
 * All previous entries here have been migrated to the lazy-loaded per-lesson
 * modules under `src/data/lessons/<track>/<id>.ts`, registered in
 * `src/data/lessons/registry.ts`. Every former key is now shadowed by a
 * registry entry, so this map is never consulted in practice.
 *
 * Kept as an empty export so `useLessonContent.ts` can continue to import it
 * without conditional logic. To add a new lesson, create a file under
 * `src/data/lessons/` and register it in `registry.ts`.
 */
export const interactiveLessons: Record<string, LessonContentData> = {};
